module.exports = __webpack_public_path__ + "img/order_no-permission.77b11de3.png";